import { render } from "./statsDatas.vue?vue&type=template&id=4bc7a5f2&scoped=true"
import script from "./statsDatas.vue?vue&type=script&lang=js"
export * from "./statsDatas.vue?vue&type=script&lang=js"

import "./statsDatas.vue?vue&type=style&index=0&id=4bc7a5f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bc7a5f2"]])

export default __exports__